import React from 'preact/compat'

import Modal from '#components/Modal'

import TwoFAEnableForm from './TwoFAEnableForm'
import TwoFADisableForm from './TwoFADisableForm'

export default ({
  type,
  onClose
}: {
  type: 'enable' | 'disable',
  onClose: () => void
}) => {
  if (type === 'enable') {
    return <Modal showClose onClose={onClose} disableOutsideClose>
      <TwoFAEnableForm close={onClose}/>
    </Modal>
  } else {
    return <Modal showClose onClose={onClose} disableOutsideClose>
      <TwoFADisableForm close={onClose}/>
    </Modal>
  }
}
